import React, { useState, useMemo, useEffect, useCallback } from "react";
import useShopSettings from "../hooks/useShopBySuppliers";
import { Dropdown } from "components";
import { useAuth } from "hooks/useAuth";

// Розподіл постачальників по магазинах
const ShopsBySuppliersSelectors = React.memo(() => {
  const { shopOptions, supplierOptions, shopSuppliersMap, isLoading, applyChanges } =
    useShopSettings();
  const { isAllowed } = useAuth();

  const [selectedShop, setSelectedShop] = useState("");
  const [selectedSupplierIds, setSelectedSupplierIds] = useState([]);
  const [initialSupplierIds, setInitialSupplierIds] = useState([]);

  // Вибір першого магазину за замовчуванням
  useEffect(() => {
    if (shopOptions.length && !selectedShop) {
      setSelectedShop(shopOptions[0].value);
    }
  }, [shopOptions, selectedShop]);

  // Синхронізація списку постачальників при зміні магазину
  useEffect(() => {
    if (!selectedShop) return;
    const list = shopSuppliersMap[selectedShop] || [];
    setSelectedSupplierIds(list);
    setInitialSupplierIds(list);
  }, [selectedShop, shopSuppliersMap]);

  // Перевірка наявності незбережених змін (незалежно від порядку)
  const hasChanges = useMemo(() => {
    if (initialSupplierIds.length !== selectedSupplierIds.length) return true;

    const a = [...initialSupplierIds].sort();
    const b = [...selectedSupplierIds].sort();
    return !a.every((v, i) => v === b[i]);
  }, [initialSupplierIds, selectedSupplierIds]);

  const handleApply = useCallback(async () => {
    await applyChanges(selectedShop, selectedSupplierIds);

    // Скидання стану для блокування кнопки після збереження
    setInitialSupplierIds(selectedSupplierIds);
  }, [selectedShop, selectedSupplierIds, applyChanges]);

  return (
    <div id="shop-suppliers-selectors">
      <div className="field">
        <label htmlFor="shop-dropdown">Магазин</label>
        <Dropdown
          inputId="shop-dropdown"
          options={shopOptions}
          selected={selectedShop}
          onChange={setSelectedShop}
          placeholder="Виберіть магазин"
        />
      </div>

      <div className="field">
        <label htmlFor="supplier-dropdown">Постачальники</label>
        <Dropdown
          inputId="supplier-dropdown"
          multiple
          options={supplierOptions}
          selected={selectedSupplierIds}
          onChange={setSelectedSupplierIds}
          placeholder="Виберіть постачальників"
        />
      </div>

      <button
        className="apply-button focus-button"
        onClick={handleApply}
        disabled={!isAllowed("shop-settings:edit") || !selectedShop || !hasChanges}
      >
        {isLoading ? "Оновлення..." : "Оновити"}
      </button>
    </div>
  );
});

export default ShopsBySuppliersSelectors;
